





























import Vue from 'vue';
import NoteModal from '@/web/components/customers/NoteModal.vue';

export default Vue.extend({
  name: 'CustomerNotesModal',
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      customerNotesFields: [
        {
          name: 'title',
          title: this.$t('CUSTOMERS.TABLE.TITLE'),
          cssClass: 'h5',
        },
        {
          name: 'updated',
          title: this.$t('GENERAL.LABEL.UPDATED'),
        },
      ],
    };
  },
  computed: {
    customerNotesQuery() {
      return {
        customerId: this.customerId,
        q: '',
      };
    },
  },
  methods: {
    openCustomerNote(customerNote) {
      this.$modal.show(
        NoteModal,
        {
          note: customerNote,
          customerId: this.customerId,
        },
        {
          classes: ['vm--inline-modal'],
        },
        {
          editNote: () => {
            this.$emit('close');
          },
        }
      );
    },
  },
});
